import { pathOr } from 'ramda';

import {
  EDealType,
  fetchGetHouseOfferHistoryDesktop,
  IGetHouseOfferHistoryDesktopResponse200,
  IGetHouseOfferHistoryDesktopResponse400,
} from '../../../repositories/valuation-offer-history/v2/get-house-offer-history-desktop';
import { IThunkActionCreator } from '../../';
import { EActionTypes } from './actionTypes';
import { IOfferHistoryData } from '../types';
import { prepareOfferHistory } from '../mappers';

export const requestAction = () => ({ type: EActionTypes.request });
export const successAction = (payload: IOfferHistoryData) => ({ type: EActionTypes.success, payload });
export const successLoadMoreAction = (payload: IOfferHistoryData) => ({
  type: EActionTypes.successLoadMore,
  payload,
});
export const failureAction = () => ({ type: EActionTypes.failure });

const getSuccessAction = (isLoadMore?: boolean) => (isLoadMore ? successLoadMoreAction : successAction);

export const getOfferHistory = (isLoadMore?: boolean): IThunkActionCreator<Promise<void>> => (
  dispatch,
  getState,
  context,
) => {
  const timeout = context.config.get<number>('valuationOfferHistory.timeout') || 3000;
  let houseId;
  const {
    offerHistory: { page, roomsFiltersActiveIDs, statusFiltersActiveIDs, resultsOnPage },
    offerData: {
      offer: {
        dealType,
        geo: { address },
      },
    },
  } = getState();

  const house = address.find(a => a.type === 'house');
  houseId = house && house.id;

  if (!houseId) {
    dispatch(failureAction());

    return Promise.resolve();
  }

  dispatch(requestAction());

  return fetchGetHouseOfferHistoryDesktop<
    IGetHouseOfferHistoryDesktopResponse200,
    IGetHouseOfferHistoryDesktopResponse400
  >({
    httpApi: context.httpApi,
    config: {
      ecnhancersConfig: { timeout },
    },
    parameters: {
      houseId,
      resultsOnPage,
      page,
      dealType: dealType as EDealType,
      offerStatus: pathOr(null, [0], statusFiltersActiveIDs),
      roomsCount: pathOr(null, [0], roomsFiltersActiveIDs),
    },
  })
    .then(res => {
      if (res.statusCode === 200) {
        const offerHistoryData = prepareOfferHistory(res.response);
        dispatch(getSuccessAction(isLoadMore)(offerHistoryData));
      } else {
        dispatch(failureAction());
      }
    })
    .catch(e => {
      context.logger.error(e);
      dispatch(failureAction());
    });
};
